import { render } from "./PostDetailPage.vue?vue&type=template&id=0b9dabe8&scoped=true"
import script from "./PostDetailPage.vue?vue&type=script&lang=js"
export * from "./PostDetailPage.vue?vue&type=script&lang=js"

import "./PostDetailPage.vue?vue&type=style&index=0&id=0b9dabe8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b9dabe8"]])

export default __exports__